import React, { lazy } from 'react';
import { JournalEntryRoutes } from '../ProjectCostingModule/ProjectCostingRoutes/JournalEntryRoutes';

const ProjectCostAdjustmentListing = lazy(() =>
  import('./ProjectCostAdjustmentListing').then(module => ({
    default: module.ProjectCostAdjustmentListing,
  })),
);

const ProjectCostAdjustmentForm = lazy(() =>
  import('./ProjectCostAdjustmentForm').then(module => ({
    default: module.ProjectCostAdjustmentForm,
  })),
);

const ProjectCostAdjustmentItemForm = lazy(() =>
  import('./components/ProjectCostAdjustmentItemForm').then(module => ({
    default: module.ProjectCostAdjustmentItemForm,
  })),
);

const ProjectCostAdjustmentDetail = lazy(() =>
  import('./ProjectCostAdjustmentDetail').then(module => ({
    default: module.ProjectCostAdjustmentDetail,
  })),
);

const CostingPreviewDetailPDF = lazy(() =>
  import(
    '../ProjectCostingModule/ProjectCostingPDF/CostingPreviewDetailPDF'
  ).then(module => ({
    default: module.CostingPreviewDetailPDF,
  })),
);

const projectCostAdjustmentRoutes = [
  ...JournalEntryRoutes,
  {
    props: {
      exact: true,
      path: '/project-journal',
    },
    component: <ProjectCostAdjustmentListing />,
  },
  {
    props: {
      exact: true,
      path: '/project-journal/detail/:costAdjustmentID',
    },
    component: <ProjectCostAdjustmentDetail />,
  },
  {
    props: {
      exact: true,
      path: '/project-journal/new',
    },
    component: <ProjectCostAdjustmentForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path: '/project-journal/approve-reject/:costAdjustmentID',
    },
    component: <ProjectCostAdjustmentForm mode="approve-reject" />,
  },
  {
    props: {
      exact: true,
      path: '/project-journal/approve-reject/workdesk/:costAdjustmentID',
    },
    component: <ProjectCostAdjustmentForm mode="approve-reject" />,
  },
  {
    props: {
      exact: true,
      path: '/project-journal/:formMode/:costAdjustmentID',
    },
    component: <ProjectCostAdjustmentForm mode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/project-journal/:formMode/item/add',
    },
    component: <ProjectCostAdjustmentItemForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path: '/project-journal/:formMode/item/:itemMode/:itemID',
    },
    component: <ProjectCostAdjustmentItemForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path: '/project-journal/:formMode/:costAdjustmentID/item/add',
    },
    component: <ProjectCostAdjustmentItemForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/project-journal/:formMode/:costAdjustmentID/item/:itemMode/:itemID',
    },
    component: <ProjectCostAdjustmentItemForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path: '/project-journal/detail/:costAdjustmentID/journal-entry/e-letter',
    },
    component: (
      <CostingPreviewDetailPDF
        docType="journal-entry"
        accountType="project-costing"
        entityIdParam="costAdjustmentID"
      />
    ),
  },
];

export default projectCostAdjustmentRoutes;
